module.exports = __webpack_public_path__ + "static/media/Weeds-Reuters.b3ce3f54.jpg";